import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ErrorBlobComponent } from '@shared/components/error-blob/error-blob.component';

@Component({
  selector: 'app-error-404',
  imports: [
    ErrorBlobComponent
  ],
  templateUrl: './error-404.component.html',
  styleUrl: './error-404.component.css'
})
export class Error404Component {
  public router: Router = inject(Router);

}
